import { Spinner } from './Spinner';

export function FullScreenLoader() {
  return (
    <div className="fixed grid h-full w-full place-items-center bg-gray-50">
      <Spinner className="h-16 w-16" />
    </div>
  );
}
